import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "../../data/content";

const Stars = ({ n }) => (
  <div className="flex gap-0.5">
    {[1, 2, 3, 4, 5].slice(0, n).map((star) => (
      <Star key={`star-${star}`} className="h-4 w-4 fill-blue-500 text-blue-500" />
    ))}
  </div>
);

export const Testimonials = () => {
  const featured = TESTIMONIALS.find((t) => t.featured);
  const rest = TESTIMONIALS.filter((t) => !t.featured);

  return (
    <section className="py-24 sm:py-32 border-b border-zinc-800/60" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-16">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-blue-500">Reviews</span>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-none text-white mt-4">
            Trusted Across the Valley
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          <div
            data-testid="featured-testimonial"
            className="relative bg-[#121212] border border-blue-500/30 rounded-xl p-8 sm:p-10 shadow-[0_0_40px_-12px_rgba(37,99,235,0.3)]"
          >
            <Quote className="h-8 w-8 text-blue-500/40 mb-5" />
            <Stars n={featured.rating} />
            <p className="text-zinc-300 leading-relaxed mt-5 mb-6">"{featured.text}"</p>
            <div className="font-heading font-semibold text-white">{featured.name}</div>
            <div className="text-sm text-zinc-500">{featured.location}, Las Vegas Valley</div>
          </div>

          <div className="grid gap-8">
            {rest.map((t) => (
              <div
                key={t.name}
                data-testid={`testimonial-${t.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="bg-[#121212] border border-zinc-800 rounded-xl p-6 sm:p-8"
              >
                <Stars n={t.rating} />
                <p className="text-zinc-300 text-sm leading-relaxed mt-4 mb-4">"{t.text}"</p>
                <span className="font-heading font-semibold text-white text-sm">{t.name}</span>
                <span className="text-sm text-zinc-500"> · {t.location}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
